export const steps = {
  qualification: {
    id: 1,
    label: 'Qualifications and Experience',
    intlKey: 'wizard.qualification_and_experience',
    completed: false,
    active: true,
    path: '/qualifications',
    next: '/success',
    allowedPaths: ['/qualifications', '/success']
  }
}

const rootPath = '/register/activity'

export const wizard = Object.keys(steps).map(item => {
  const currentStep = steps[item]

  let allowedPaths = currentStep.allowedPaths.concat(currentStep.next)

  allowedPaths = currentStep.allowedPaths.map(
    allowedPath => rootPath + allowedPath
  )

  return {
    id: currentStep.id,
    label: currentStep.label,
    completed: false,
    active: currentStep.active,
    intlKey: currentStep.intlKey,
    next: rootPath + currentStep.next,
    path: rootPath + currentStep.path,
    rootPath,
    allowedPaths
  }
})
